import React from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const LegalNoticesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-slate-50 to-blue-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 bg-blue-600 rounded-lg flex items-center justify-center">
              <i className="ri-file-text-line text-2xl text-white"></i>
            </div>
            <h1 className="text-4xl font-bold text-slate-900">Legal Notices</h1>
          </div>
          <p className="text-lg text-slate-600">
            Important legal information about our company and website operations
          </p>
          <p className="text-sm text-slate-500 mt-2">
            Last updated: January 2025
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-slate max-w-none">
          
          {/* Company Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-building-line text-blue-600"></i>
              Company Information
            </h2>
            <div className="bg-slate-50 rounded-lg p-6 space-y-3">
              <div>
                <strong className="text-slate-900">Company Name:</strong>
                <p className="text-slate-700 mt-1">GlobalShip Logistics International Ltd.</p>
              </div>
              <div>
                <strong className="text-slate-900">Legal Form:</strong>
                <p className="text-slate-700 mt-1">Limited Liability Company</p>
              </div>
              <div>
                <strong className="text-slate-900">Registered Office:</strong>
                <p className="text-slate-700 mt-1">
                  125 Business Park Drive, Suite 400<br />
                  London, EC2A 4NE<br />
                  United Kingdom
                </p>
              </div>
              <div>
                <strong className="text-slate-900">Company Registration Number:</strong>
                <p className="text-slate-700 mt-1">GB-12345678</p>
              </div>
              <div>
                <strong className="text-slate-900">VAT Number:</strong>
                <p className="text-slate-700 mt-1">GB987654321</p>
              </div>
              <div>
                <strong className="text-slate-900">Trade Register:</strong>
                <p className="text-slate-700 mt-1">Companies House, United Kingdom</p>
              </div>
            </div>
          </section>

          {/* Website Publisher */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-user-line text-blue-600"></i>
              Website Publisher
            </h2>
            <div className="bg-slate-50 rounded-lg p-6 space-y-3">
              <div>
                <strong className="text-slate-900">Publication Director:</strong>
                <p className="text-slate-700 mt-1">Michael Ashley, Chief Executive Officer</p>
              </div>
              <div>
                <strong className="text-slate-900">Editorial Responsibility:</strong>
                <p className="text-slate-700 mt-1">GlobalShip Logistics International Ltd.</p>
              </div>
              <div>
                <strong className="text-slate-900">Contact Email:</strong>
                <p className="text-slate-700 mt-1">legal@globalship.com</p>
              </div>
              <div>
                <strong className="text-slate-900">Contact Phone:</strong>
                <p className="text-slate-700 mt-1">+44 20 7123 4567</p>
              </div>
            </div>
          </section>

          {/* Hosting Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-server-line text-blue-600"></i>
              Hosting Information
            </h2>
            <div className="bg-slate-50 rounded-lg p-6 space-y-3">
              <div>
                <strong className="text-slate-900">Hosting Provider:</strong>
                <p className="text-slate-700 mt-1">Amazon Web Services EMEA SARL</p>
              </div>
              <div>
                <strong className="text-slate-900">Address:</strong>
                <p className="text-slate-700 mt-1">
                  38 Avenue John F. Kennedy<br />
                  L-1855 Luxembourg<br />
                  Luxembourg
                </p>
              </div>
              <div>
                <strong className="text-slate-900">Website:</strong>
                <p className="text-slate-700 mt-1">
                  <a href="https://aws.amazon.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700">
                    aws.amazon.com
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Intellectual Property */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-copyright-line text-blue-600"></i>
              Intellectual Property Rights
            </h2>
            <div className="space-y-4 text-slate-700">
              <p>
                All content on this website, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, data compilations, and software, is the property of GlobalShip Logistics International Ltd. or its content suppliers and is protected by international copyright laws.
              </p>
              <p>
                The compilation of all content on this website is the exclusive property of GlobalShip Logistics International Ltd. and is protected by international copyright laws. All software used on this website is the property of GlobalShip Logistics International Ltd. or its software suppliers and is protected by international copyright laws.
              </p>
              <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded">
                <p className="font-semibold text-slate-900 mb-2">Trademark Notice</p>
                <p>
                  GlobalShip®, the GlobalShip logo, and other marks indicated on our website are registered trademarks of GlobalShip Logistics International Ltd. in the United Kingdom and other countries. Other GlobalShip graphics, logos, page headers, button icons, scripts, and service names are trademarks or trade dress of GlobalShip Logistics International Ltd.
                </p>
              </div>
              <p>
                Unauthorized use of any content or materials on this website may violate copyright, trademark, and other laws. You may not modify, copy, reproduce, republish, upload, post, transmit, or distribute in any way any material from this website without prior written permission from GlobalShip Logistics International Ltd.
              </p>
            </div>
          </section>

          {/* Limitation of Liability */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-shield-line text-blue-600"></i>
              Limitation of Liability
            </h2>
            <div className="space-y-4 text-slate-700">
              <p>
                The information contained on this website is provided for general information purposes only. While we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.
              </p>
              <p>
                Any reliance you place on such information is therefore strictly at your own risk. In no event will GlobalShip Logistics International Ltd. be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
              </p>
              <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded">
                <p className="font-semibold text-slate-900 mb-2">Important Notice</p>
                <p>
                  Through this website, you may be able to link to other websites which are not under the control of GlobalShip Logistics International Ltd. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
                </p>
              </div>
              <p>
                Every effort is made to keep the website up and running smoothly. However, GlobalShip Logistics International Ltd. takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
              </p>
            </div>
          </section>

          {/* Applicable Law */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-scales-line text-blue-600"></i>
              Applicable Law and Jurisdiction
            </h2>
            <div className="space-y-4 text-slate-700">
              <p>
                These legal notices and your use of this website are governed by and construed in accordance with the laws of England and Wales, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
              <div className="bg-slate-50 rounded-lg p-6">
                <p className="font-semibold text-slate-900 mb-3">Dispute Resolution</p>
                <p className="mb-3">
                  In the event of any dispute arising out of or in connection with these legal notices or the use of this website, the parties shall first attempt to resolve the dispute through good faith negotiations.
                </p>
                <p>
                  If the dispute cannot be resolved through negotiations within thirty (30) days, either party may submit the dispute to the exclusive jurisdiction of the courts of England and Wales.
                </p>
              </div>
            </div>
          </section>

          {/* Professional Regulations */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-file-list-line text-blue-600"></i>
              Professional Regulations
            </h2>
            <div className="bg-slate-50 rounded-lg p-6 space-y-3">
              <div>
                <strong className="text-slate-900">Industry Regulations:</strong>
                <p className="text-slate-700 mt-1">
                  GlobalShip Logistics International Ltd. operates in accordance with international shipping and logistics regulations, including but not limited to:
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-slate-700">
                  <li>International Air Transport Association (IATA) regulations</li>
                  <li>International Maritime Organization (IMO) conventions</li>
                  <li>World Customs Organization (WCO) standards</li>
                  <li>UK Civil Aviation Authority (CAA) requirements</li>
                  <li>Maritime and Coastguard Agency (MCA) regulations</li>
                </ul>
              </div>
              <div className="mt-4">
                <strong className="text-slate-900">Professional Memberships:</strong>
                <ul className="list-disc list-inside mt-2 space-y-1 text-slate-700">
                  <li>British International Freight Association (BIFA)</li>
                  <li>Freight Transport Association (FTA)</li>
                  <li>International Federation of Freight Forwarders Associations (FIATA)</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Contact for Legal Matters */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-mail-line text-blue-600"></i>
              Contact for Legal Matters
            </h2>
            <div className="bg-blue-50 rounded-lg p-6">
              <p className="text-slate-700 mb-4">
                For any legal inquiries, notices, or concerns regarding this website or our services, please contact our legal department:
              </p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-blue-600 mt-1"></i>
                  <div>
                    <strong className="text-slate-900">Postal Address:</strong>
                    <p className="text-slate-700">
                      Legal Department<br />
                      GlobalShip Logistics International Ltd.<br />
                      125 Business Park Drive, Suite 400<br />
                      London, EC2A 4NE<br />
                      United Kingdom
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-blue-600"></i>
                  <div>
                    <strong className="text-slate-900">Email:</strong>
                    <a href="mailto:legal@globalship.com" className="text-blue-600 hover:text-blue-700 ml-2">
                      legal@globalship.com
                    </a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-blue-600"></i>
                  <div>
                    <strong className="text-slate-900">Phone:</strong>
                    <span className="text-slate-700 ml-2">+44 20 7123 4567</span>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-time-line text-blue-600"></i>
                  <div>
                    <strong className="text-slate-900">Business Hours:</strong>
                    <span className="text-slate-700 ml-2">Monday - Friday, 9:00 AM - 6:00 PM GMT</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Amendments */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <i className="ri-refresh-line text-blue-600"></i>
              Amendments to Legal Notices
            </h2>
            <div className="space-y-4 text-slate-700">
              <p>
                GlobalShip Logistics International Ltd. reserves the right to modify these legal notices at any time. Any changes will be effective immediately upon posting on this website. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.
              </p>
              <p>
                We recommend that you review these legal notices periodically to stay informed of any updates. The date of the last revision will always be indicated at the top of this page.
              </p>
            </div>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LegalNoticesPage;
